import { GetDamagedImagesTabsQueryParamsType } from '@/modules/adjusterReportModules/IncidentParticipants/queries/getDamagedImagesTabs/getDamagedImagesTabsQuery.type';
import { getDamagedImagesTabsFunction } from '@/modules/adjusterReportModules/IncidentParticipants/queries/getDamagedImagesTabs/getDamagedImagesTabsQueryFunction';
import { getInitialVisitImagesTabFunction } from '@/modules/adjusterReportModules/IncidentParticipants/queries/getDamagedImagesTabs/getInitialVisitImagesTabQueryFunction';
import { queryOptions } from '@tanstack/react-query';

export const getDamagedImagesTabsQueryOptions = (
  params: GetDamagedImagesTabsQueryParamsType,
) => {
  if (params.type === 'initial_visit') {
    return queryOptions({
      queryKey: ['GET_INITIAL_IMAGE_TABS', params],
      queryFn: () => getInitialVisitImagesTabFunction(params),
    });
  }
  return queryOptions({
    queryKey: ['GET_DAMAGED_IMAGE_TABS', params],
    queryFn: () => getDamagedImagesTabsFunction(params),
  });
};
